import { Component, OnInit, Output, EventEmitter, Input, ViewChild } from '@angular/core';
import { CommonService } from 'src/app-core/services/common.service';
import { ContainerNoncushioningListComponent } from '../container-noncushioning-list/container-noncushioning-list.component';
import { ContainerCushioningListComponent } from '../container-cushioning-list/container-cushioning-list.component';
import { OrdersItemSpacingComponent } from '../orders-item-spacing/orders-item-spacing.component';
import { MatDialog } from '@angular/material';
import { OrdersConatinerFutureUseFormComponent } from '../orders-conatiner-future-use-form/orders-conatiner-future-use-form.component';
import * as _ from 'lodash';
import { CommonDataModel } from '../common-data-model';
import { ToastrService } from 'ngx-toastr';
import { OrderTypeEnum, UnitsEnum } from '../app-common-enum';
import { finalize } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';
import { CommonConstants } from 'src/app-core/constants/common-constants';

@Component({
    selector: 'app-orders-packaging',
    templateUrl: './orders-container-packaging.component.html',
    styleUrls: ['./orders-container-packaging.component.scss']
})
export class OrdersContainerPackagingComponent implements OnInit {
    @ViewChild('nonCushioningList', { static: false }) nonCushioningList: ContainerNoncushioningListComponent;
    @ViewChild('cushioningList', { static: false }) cushioningList: ContainerCushioningListComponent;
    @ViewChild('itemSpacing', { static: false }) itemSpacing: OrdersItemSpacingComponent;
    @Input() set collapsingValue(collapsingValue: any) {
        if (collapsingValue) {
            this.packagingCollapsing = collapsingValue;
        }
    }
    @Input() orderTypeId: any;
    @Input() set containerIdParam(containerId: number) {
        if (containerId) {
            this.containerId = containerId;
            this.getPackaging();
        }
    }
    @Input() set containerData(containerData: any) {
        this.containerDetails = containerData;
        if (this.containerDetails) {
            this.createHeaderString();
        }
    }

    @Input() set containerSummaryParams(data: any) {
        this.containerSummary = data;
    }
    @Input() readOnly: boolean;
    @Output() emitGetContainerToggle: EventEmitter<any> = new EventEmitter<any>();
    @Output() emitChangeContainerSummary: EventEmitter<any> = new EventEmitter<any>();
    @Output() getContainerDetails: EventEmitter<any> = new EventEmitter<any>();
    orderTypeEnum: typeof OrderTypeEnum = OrderTypeEnum;
    containerId: any;
    containerDetails: any;
    twoLineItemString: string;
    allLineItemString: string;
    packagingDetails: any;
    packagingDetailsCopy: any;
    containerSummary: any;
    enableSavebutton = false;
    cushioningInitialItems: any;
    nonCushioningInitialItems: any;
    isFormLoading = false;
    enablePackaging = true;
    containerQuantity: any;
    commonDatamodel = new CommonDataModel();
    updatePackagingModel = _.cloneDeep(this.commonDatamodel.updatePackagingModel);
    containerDimention = _.cloneDeep(this.commonDatamodel.containerDimention);
    isMaterialLocked = false;
    isTotalsLocked = false;
    isPartiallyLocked = false;
    orderId: any;
    isJob = true;

    packagingCollapsing: any;
    constructor(
        private commonService: CommonService,
        private toastr: ToastrService,
        private dialog: MatDialog,
        private activatedRoute: ActivatedRoute
    ) {
        if (this.activatedRoute.snapshot.queryParams.jobId) {
            this.orderId = this.activatedRoute.snapshot.queryParams.jobId;
            this.isJob = true;
        } else {
            this.orderId = this.activatedRoute.snapshot.queryParams.quoteId;
            this.isJob = false;
        }
    }

    ngOnInit() {
    }

    collapseEmit(event: any) {
        if (this.nonCushioningList) {
            this.packagingCollapsing.nonCushioning = this.nonCushioningList.isExpanded;
        }
        if (this.cushioningList) {
            this.packagingCollapsing.cushioning = this.cushioningList.isExpanded;
        }
        if (this.itemSpacing) {
            this.packagingCollapsing.itemSpacing = this.itemSpacing.isExpanded;
        }
    }

    getPackaging() {
        this.isFormLoading = true;
        this.commonService.getQuotePackaging(this.containerId).subscribe(response => {
            if (response.data && response.data.packaging) {
                this.isMaterialLocked = response.data.isMaterialLocked;
                this.isPartiallyLocked = response.data.isPartialLocked;
                this.isTotalsLocked = response.data.isTotalLocked;
                this.packagingDetails = _.cloneDeep(response.data.packaging);
                this.packagingDetailsCopy = _.cloneDeep(response.data.packaging);
                this.nonCushioningList.gridItems.data = _.cloneDeep(response.data.packaging.materials);
                this.nonCushioningInitialItems = _.cloneDeep(response.data.packaging.materials);
                this.nonCushioningList.gridItems.total = _.cloneDeep(response.data.packaging.materials.length);
                this.cushioningList.gridItems.data = _.cloneDeep(response.data.packaging.cushioningMaterials);
                this.cushioningInitialItems = _.cloneDeep(response.data.packaging.cushioningMaterials);
                this.cushioningList.gridItems.total = _.cloneDeep(response.data.packaging.cushioningMaterials.length);
                if (response.data.packaging.itemSpacing) {
                    this.itemSpacing.spaceCheckBox.isTop = false;
                    this.itemSpacing.spaceCheckBox.isBottom = false;
                    this.itemSpacing.spaceCheckBox.isSideOne = false;
                    this.itemSpacing.spaceCheckBox.isSideTwo = false;
                    this.itemSpacing.spaceCheckBox.isEndOne = false;
                    this.itemSpacing.spaceCheckBox.isEndtwo = false;
                    this.itemSpacing.gridItems.data = _.cloneDeep([response.data.packaging.itemSpacing]);
                } else {
                    this.itemSpacing.gridItems.data[0].spacingId = 0;
                    this.itemSpacing.onClearAllSpaces();
                }
                this.nonCushioningList.containerQuantity = response.data.packaging.containerQuanity;
                this.cushioningList.containerQuantity = response.data.packaging.containerQuanity;
                this.cushioningList.containerDimention = _.cloneDeep(response.data.dimension);
                this.nonCushioningList.containerDimention = _.cloneDeep(response.data.dimension);
                this.containerDimention = _.cloneDeep(response.data.dimension);
                this.containerQuantity = response.data.packaging.containerQuanity;
                this.itemSpacing.setCheckAllCheckbox();
            } else {
                this.enablePackaging = false;
            }
            this.isFormLoading = false;
        });
    }

    resetResourse() {
        this.twoLineItemString = null;
        this.allLineItemString = null;
        this.packagingDetails = null;
        this.packagingDetailsCopy = null;
        this.enableSavebutton = false;
        this.cushioningInitialItems = null;
        this.nonCushioningInitialItems = null;
        this.isFormLoading = false;
        this.enablePackaging = true;
        this.updatePackagingModel = _.cloneDeep(this.commonDatamodel.updatePackagingModel);
        this.resetForm();
    }

    resetForm() {
        this.nonCushioningList.nonCushioningMaterialForm.form.markAsPristine();
        this.cushioningList.cushioningMaterialForm.form.markAsPristine();
        this.itemSpacing.itemSpacingForm.form.markAsPristine();
        this.enableSavebutton = false;
    }

    createHeaderString() {
        this.twoLineItemString = '';
        this.allLineItemString = '';
        this.containerDetails.lineItems.map((item, index) => {
            this.allLineItemString += `${(item.categoryName) ? item.categoryName : ''}
        ${item.length}x${item.width}x${item.height}${(this.containerDetails.lineItems.length - 1) !== index ? ', ' : ' '}`;
            if (index < 2) {
                this.twoLineItemString += `${(item.categoryName) ? item.categoryName : ''}
          ${item.length}x${item.width}x${item.height}${(index === 0 && this.containerDetails.lineItems.length > 1) ? ', ' :
                        (index === 1 && this.containerDetails.lineItems.length > 2) ? ', ' : ''
                    }`;
            }
        });
    }

    onFutureUse() {
        this.dialog.open(OrdersConatinerFutureUseFormComponent, {
            panelClass: 'small_center_layout',
            hasBackdrop: false,
            data: { containerDetails: {} },
        }).afterClosed().subscribe((response: any) => {
            if (response && response.confirmResult === true) {
                if (response.selectedContainer === 0) {
                }
            }
        });
    }

    onToggleConatinerSummary() {
        this.emitGetContainerToggle.emit();
    }

    onCancelChanges() {
        if (this.packagingDetailsCopy) {
            this.emitChangeContainerSummary.emit();
            this.nonCushioningList.gridItems.data = _.cloneDeep(this.packagingDetailsCopy.materials);
            this.nonCushioningList.gridItems.total = _.cloneDeep(this.packagingDetailsCopy.materials.length);
            this.cushioningList.gridItems.data = _.cloneDeep(this.packagingDetailsCopy.cushioningMaterials);
            this.cushioningList.gridItems.total = _.cloneDeep(this.packagingDetailsCopy.cushioningMaterials.length);
            this.itemSpacing.spaceCheckBox = _.cloneDeep(this.packagingDetailsCopy.itemSpacing);
            this.itemSpacing.gridItems.data = _.cloneDeep([this.packagingDetailsCopy.itemSpacing]);
        }
    }

    getCushioningMaterials(): any {
        if (this.cushioningInitialItems && this.cushioningInitialItems.length > 0) {
            const deletedItems: Array<any> = [];
            this.cushioningInitialItems.forEach(material => {
                const currentmaterial = this.cushioningList.gridItems.data.find(lineitem => lineitem.packagingMaterialId == material.packagingMaterialId);
                if (!currentmaterial) {
                    material.isActive = false;
                    deletedItems.push(material);
                }
            });
            return _.union(this.cushioningList.gridItems.data, deletedItems);
        } else {
            return this.cushioningList.gridItems.data;
        }
    }

    getNonCushioningMaterials(): any {
        if (this.nonCushioningInitialItems && this.nonCushioningInitialItems.length > 0) {
            const deletedItems: Array<any> = [];
            this.nonCushioningInitialItems.forEach(material => {
                const currentmaterial = this.nonCushioningList.gridItems.data.find(lineitem => lineitem.packagingMaterialId == material.packagingMaterialId);
                if (!currentmaterial) {
                    material.isActive = false;
                    deletedItems.push(material);
                }
            });
            return _.union(this.nonCushioningList.gridItems.data, deletedItems);
        } else {
            return this.nonCushioningList.gridItems.data;
        }
    }

    onEnableSaveButton() {
        if ((this.nonCushioningList && this.nonCushioningList.nonCushioningMaterialForm.dirty) ||
            (this.itemSpacing && this.itemSpacing.itemSpacingForm.dirty) ||
            (this.cushioningList && this.cushioningList.cushioningMaterialForm.dirty)) {
            if ((this.nonCushioningList && this.nonCushioningList.nonCushioningMaterialForm.valid) &&
                (this.itemSpacing && this.itemSpacing.itemSpacingForm.valid) &&
                (this.cushioningList && this.cushioningList.cushioningMaterialForm.form.valid)
            ) {
                this.enableSavebutton = true;
            } else {
                this.enableSavebutton = false;
            }

        }
    }

    emitEnableSaveButton() {
        this.onEnableSaveButton();
    }

    onUpdateAllChanges() {
        if (this.isMaterialLocked || this.isTotalsLocked) {
            this.commonService.getConfirmationPopup(`Totals are locked!?
      Do you want to Unlock and recalculate?`, null, null, true).then(result => {
                if (result) {
                    this.updatePackagingModel.isLockedChanged = true;
                    this.updatepackaging();
                } else {
                    this.updatepackaging();
                }
            });
        } else {
            this.updatepackaging();
        }
    }

    updatepackaging() {
        this.commonService.objectMapping(this.updatePackagingModel, this.packagingDetails);
        this.updatePackagingModel.packaging.materials = this.getNonCushioningMaterials();
        this.updatePackagingModel.packaging.cushioningMaterials = this.getCushioningMaterials();
        this.commonService.objectMapping(this.updatePackagingModel, this.containerSummary);
        this.updatePackagingModel.packaging = {
            id: this.packagingDetails.id,
            isCorporate: this.packagingDetails.isCorporate,
            itemSpacing: this.itemSpacing.gridItems.data[0],
            materials: this.updatePackagingModel.packaging.materials,
            cushioningMaterials: this.updatePackagingModel.packaging.cushioningMaterials,
            name: this.packagingDetails.name
        };
        this.updatePackagingModel.laborCalculation = this.containerSummary.laborCalculation;
        this.isFormLoading = true;
        this.commonService.updateOrderPackaging(this.updatePackagingModel)
            .pipe(finalize(() => (this.isFormLoading = false))).subscribe(response => {
                this.isFormLoading = false;
                if (response.isSuccess) {
                    if ((this.isJob)) {
                        this.toastr.success(CommonConstants.updateOrderModifierNotificationConstants.updateJobOrderModifierNotification);
                    } else if ((!this.isJob)) {
                        this.toastr.success(CommonConstants.updateOrderModifierNotificationConstants.updateQuoteOrderModifierNotification);
                    } else {
                        this.toastr.success(CommonConstants.updateOrderModifierNotificationConstants.updateQuoteJobOrderModifierNotification);
                    }
                    this.resetResourse();
                    //  this.getPackaging();
                    this.createHeaderString();
                    this.getContainerDetails.emit();
                }
            });
    }

    reCalculatePackagingQuantity(data: any) {
        this.calculatePrep();
        this.onEnableSaveButton();
    }

    CalculateCushioningUnits(length: any, width: any, height: any) {
        let sideCount = 0;
        let endCount = 0;
        let topBottomCount = 0;
        let newLength = length;
        let newWidth = width;
        let newHeight = height;
        if (this.cushioningList.gridItems.data.length > 0) {
            this.cushioningList.gridItems.data.forEach(gridItem => {
                if (gridItem.cushioningDetails[0].isActive) {
                    endCount++;
                }
                if (gridItem.cushioningDetails[1].isActive) {

                    endCount++;
                }
                if (gridItem.cushioningDetails[2].isActive) {
                    sideCount++;
                }
                if (gridItem.cushioningDetails[3].isActive) {
                    sideCount++;
                }
                if (gridItem.cushioningDetails[4].isActive) {
                    topBottomCount++;
                }
                if (gridItem.cushioningDetails[5].isActive) {
                    topBottomCount++;
                }
                let calculatedFinalunits = 0;
                for (let qIndex = 0; qIndex < gridItem.quantity; qIndex++) {
                    const endUnit = newWidth * newHeight * endCount;
                    const sideLength = newLength * newHeight * sideCount;
                    const topBottomLength = newWidth * newLength * topBottomCount;
                    const extraHeight = endCount * sideCount * newHeight;
                    const extraLength = topBottomCount * sideCount * newLength;
                    const extraWidth = topBottomCount * endCount * newWidth;
                    const corner = endCount * sideCount * topBottomCount;
                    const finalUnit = endUnit + sideLength + topBottomLength + extraHeight + extraLength + extraWidth + corner;
                    calculatedFinalunits = calculatedFinalunits + finalUnit;
                    newLength = newLength + (gridItem.height * endCount);
                    newWidth = newWidth + (gridItem.height * sideCount);
                    newHeight = newHeight + (gridItem.height * topBottomCount);
                }
                let qty = 0, unitprice = 0, unitweight = 0;
                qty = gridItem.quantity;
                if (qty == 0) {
                    qty = 1;
                    gridItem.quantity = 1;
                }
                unitprice = gridItem.unitCost;
                unitweight = gridItem.unitWeight;
                calculatedFinalunits = this.GetCalculatedUnits(gridItem.unitId, calculatedFinalunits) * this.containerQuantity;
                const calculatedValues = this.GetCalculatedCost(gridItem.unitId, calculatedFinalunits, unitprice, unitweight, qty);
                gridItem.unitQuantity = calculatedFinalunits;
                gridItem.cost = calculatedValues.cost;
                gridItem.weightLBS = calculatedValues.weight;
            });
        }
    }

    calculatePrep() {
        let conLength = this.containerDimention.length;
        let conWidth = this.containerDimention.width;
        let conHeight = this.containerDimention.height;
        if (this.nonCushioningList.gridItems.data.length > 0) {
            let qty = 0, unitprice = 0, unitweight = 0, units = 0;
            this.nonCushioningList.gridItems.data.forEach(gridItem => {
                const prepMaterialThickNess = gridItem.height;
                qty = gridItem.quantity;
                if (qty == 0) {
                    qty = 1;
                }

                unitprice = gridItem.unitCost;
                unitweight = gridItem.unitWeight;
                if (gridItem.unitId === UnitsEnum.Each) {
                    units = gridItem.unitQuantity;
                } else {
                    units = (conLength * conWidth * 2) + (conWidth * conHeight * 2) + (conHeight * conLength * 2) * this.containerQuantity;
                }
                units = this.GetCalculatedUnits(gridItem.unitId, units);

                const calculatedValues = this.GetCalculatedCost(gridItem.unitId, units, unitprice, unitweight, qty);
                gridItem.unitQuantity = units;
                gridItem.cost = calculatedValues.cost;
                gridItem.weightLBS = calculatedValues.weight;
                conLength = conLength + (prepMaterialThickNess * 2 * qty);
                conWidth = conWidth + (prepMaterialThickNess * 2 * qty);
                conHeight = conHeight + (prepMaterialThickNess * 2 * qty);
            });
        }
        const newDim = this.CalculateItemSpacing(conLength, conWidth, conHeight);
        this.CalculateCushioningUnits(newDim.newlength, newDim.newheight, newDim.newwidth);
    }

    CalculateItemSpacing(length: any, width: any, height: any) {
        const data = this.itemSpacing.gridItems.data[0];
        if (data != null) {
            length = length + data.endOne + data.endtwo;
            width = width + data.sideOne + data.sideTwo;
            height = height + data.top + data.bottom;
        }
        return { newlength: length, newwidth: width, newheight: height };
    }


    GetCalculatedUnits(unitid: any, units: any) {
        let unitsValue = 0.00;
        switch (unitid) {
            case 1: // for inch
                {
                    unitsValue = units;
                }
                break;
            case 2: // for foot
                {
                    unitsValue = (units / 12);
                }
                break;
            case 3: // for Sq. in.
                {
                    unitsValue = (units);
                }
                break;
            case 4: // for Sq. Ft.
                {
                    unitsValue = (units / (12 * 12));
                }
                break;
            // for cu in
            case 5:
                {
                    unitsValue = (units);
                }
                break;
            case 6: // for cu ft
                {
                    unitsValue = (units / (12 * 12 * 12));
                }
                break;
            // each
            case 7:
                {
                    unitsValue = units;
                }
                break;
            default: {
                unitsValue = 0.00; // reset
            }
        }
        if (!units) {
            unitsValue = 0.00;
        }
        return unitsValue;
    }

    GetCalculatedCost(caseId: any, units: any, unitprice: any, unitweight: any, quantity: any) {
        let costValue = 0.00, weightValue = 0.00;
        switch (caseId) {
            case 1: // for inch
                {
                    costValue = parseFloat(quantity) * parseFloat(units) * parseFloat(parseFloat(unitprice).toFixed(6));
                    weightValue = quantity * units * unitweight;
                }
                break;
            case 2: // for foot
                {
                    costValue = quantity * units * parseFloat(parseFloat(unitprice).toFixed(6)) * 0.08334;
                    weightValue = quantity * units * unitweight * 0.08334;
                }
                break;
            case 3: // for Sq. in.
                {
                    costValue = quantity * units * parseFloat(parseFloat(unitprice).toFixed(6));
                    weightValue = quantity * units * unitweight;
                }
                break;
            case 4: // for Sq. Ft.
                {
                    costValue = quantity * units * parseFloat(parseFloat(unitprice).toFixed(6)) * 0.006945;
                    weightValue = quantity * units * unitweight * 0.006945;
                }
                break;
            case 5: // for cu in
                {
                    costValue = quantity * units * parseFloat(parseFloat(unitprice).toFixed(6));
                    weightValue = quantity * units * unitweight;
                }
                break;
            case 6: // for cu ft
                {
                    costValue = quantity * units * parseFloat(parseFloat(unitprice).toFixed(6)) * 0.000579;
                    weightValue = quantity * units * unitweight * 0.000579;
                }
                break;
            case 7: // each
                {
                    costValue = quantity * units * parseFloat(parseFloat(unitprice).toFixed(6));
                    weightValue = quantity * units * unitweight;
                }
                break;
            default: {
                costValue = 0.00, weightValue = 0.00; // reset
            }
        }
        return { cost: costValue, weight: weightValue };
    }

    onAdminRecalculation() {
        const requestData = {
            orderId: this.orderId
        };
        this.isFormLoading = true;
        this.commonService.orderAdminRecalc(requestData)
            .pipe(finalize(() => (this.isFormLoading = false))).subscribe(response => {
                if (response.isSuccess) {
                    this.isFormLoading = false;
                    this.toastr.success(response.errors || `${this.isJob ? 'Job' : `Quote`} Updated Successfully`);
                    this.resetResourse();
                    this.createHeaderString();
                    this.getContainerDetails.emit();
                }
            });
    }

}
